var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0834 10.5002C11.3928 10.5002 11.6895 10.3772 11.9083 10.1585C12.1271 9.93966 12.25 9.64292 12.25 9.3335V3.50016C12.25 3.19074 12.1271 2.894 11.9083 2.6752C11.6895 2.45641 11.3928 2.3335 11.0834 2.3335H6.47504C6.27992 2.33541 6.08744 2.28835 5.91522 2.19663C5.74299 2.10492 5.59652 1.97146 5.48921 1.8085L5.01671 1.1085C4.91048 0.947187 4.76586 0.814775 4.59583 0.723144C4.4258 0.631512 4.23569 0.583528 4.04254 0.583496H1.75004C1.44062 0.583496 1.14388 0.706412 0.925083 0.925205C0.70629 1.144 0.583374 1.44074 0.583374 1.75016V9.3335C0.583374 9.64292 0.70629 9.93966 0.925083 10.1585C1.14388 10.3772 1.44062 10.5002 1.75004 10.5002H11.0834Z",
    stroke: "#1976D2",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.39df7306.svg";
export { ForwardRef as ReactComponent };